<template>
    <div ref="layerDom" :class="$style['layer--lang-switch']" class="flex justify-center items-center" @click.self="emit('close')">
        <div ref="panelDom" :class="$style['lang-switch-panel']">
            <div v-if="token" class="langHeaderUser">
                <!-- <div>{{user.email}}</div>
                           <div>ID:{{user.id}}</div> -->
                <div class="langHeaderUserEmail">{{user.email}}</div>
                <div class="langHeaderUserId">ID:{{user.id}}<i @click="handleCopy" :data-clipboard-text='user.id' class="copy iconfont icon-fuzhi"></i></div>
            </div>
            <div :class="$style['panel-body']">
                <div :class="$style['scroll-box']">
                    <div :class="$style['lang-group']" class="overflow-hidden">
                        <div :class="$style['group-title']">
                            <span class="text">
                                <!-- Select language and region -->
                                {{$t('400005')}}
                            </span>
                        </div>
                        <div :class="$style['group-body']" class="grid grid-cols-2">
                            <button v-for="(item, index) in langOptions" :key="index" :class="$style['option']" @click="
                  () => {
                    changeCurtSelectLang(item);
                  }
                " :data-active="currentSelectLang === item.language">
                                <span class="text">{{ item.name }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="$style['langFooter']">
                <div :class="$style['langBtns']" v-if="!token">
                    <div :class="$style['btn--connect-logIn']" @click="toLogin">
                        <span :class="$style['text']">{{$t('300328')}}</span>
                    </div>
                    <div :class="$style['btn--connect-register']">
                        <span :class="$style['text']" @click="toRegister">{{$t('300041')}}</span>
                    </div>
                </div>
                <div :class="$style['downLoad']" @click="$router.push({path:'/download'})">
                    <UeIcon :class="$style['ic']" name="download" />
                    <!-- 300332 Download -->
                    <span>{{$t('300332')}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Toast } from 'vant'
    import { getLanguageList } from '@/api/user'

    import { gsap } from '../../utils/gsap'
    import { setCookie } from '@/utils/auth'
    import { exchangeOptions, langOptions } from '../../data/lang-switch'
    import { mapGetters } from 'vuex'
    // import { getUserInfo } from '@/api/user'

    import Clipboard from 'clipboard'

    import '@/assets/newCss/var.scss'
    import { getCookie } from '../../utils/auth'

    export default {
        props: {
            isShow: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                // activeTabType: "lang",
                currentSelectLang: getCookie('language'),
                // currentSelectExchange: "usd-$",
                panelDom: null,
                layerDom: null,
                // exchangeOptions,
                langOptions,
            }
        },
        computed: {
            ...mapGetters(['isDirection', 'token', 'user']),
        },
        watch: {
            isShow(val) {
                if (val) {
                    let paramsName = this.$route.query.language
                    this.currentSelectLang = getCookie('language') || 'en'
                }
            },
        },

        created() {
            this.getLanguageList()
            // this.getUserInfo()
            if (this.token) {
                this.$store.dispatch('GetInfo', this.token)
            }
            console.log(this.token, '看看token')
            console.log(this.user, '---user---')
        },

        mounted() {
            this.layerDom = this.$refs.layerDom
            this.panelDom = this.$refs.panelDom
        },

        methods: {
            toLogin() {
                this.$store.dispatch('setTrigger','public_log_in_button')
                console.log(window.location.pathname, 'window.location.pathname')
                if (!this.token) {
                    if (this.$route.path == '/contractCompetition') {
                        this.$router.push({ path: '/login', query: { historyBack: `/contractCompetition?id=${this.$route.query.id}` } });
                    } else {
                        this.$router.push(
                            '/login?historyBack=' +
                            window.encodeURIComponent(window.location.pathname)
                        )
                    }
                }
            },
            toRegister() {
                this.$store.dispatch('setTrigger','public_register_button')
                console.log(
                    window.location.pathname,
                    'window.location.pathname注册'
                )
                if (!this.token) {
                    if (this.$route.path == '/contractCompetition') {
                        this.$router.push({ path: '/register', query: { historyBack: `/contractCompetition?id=${this.$route.query.id}` } });
                    } else {
                        this.$router.push(
                            '/register?historyBack=' +
                            window.encodeURIComponent(window.location.pathname)
                        )
                    }
                }
            },
            // getUserInfo() {
            //     getUserInfo().then((res) => {
            //         console.log(res, '看看个人数据')
            //     })
            // },
            handleCopy() {
                console.log('??进了吗 ？')
                var clipboard = new Clipboard('.copy')
                clipboard.on('success', (e) => {
                    console.log('到这步了吗')
                    Toast.success(this.$t('300027'))
                    console.log('???没提示？')
                    // 释放内存
                    clipboard.destroy()
                    console.log('走完了吗')
                })
                clipboard.on('error', (e) => {
                    Toast.fail(this.$t('300028'))
                    // 释放内存
                    clipboard.destroy()
                })
            },
            // changeCurtSelectLang(item) {
            //     this.$emit('closeLangModal')
            //     this.currentSelectLang = item.language
            //     let path = this.$route.name
            //     this.$router.replace(`/${path}?language=${item.language}`)
            //     setTimeout(() => {
            //         location.reload()
            //     }, 200)
            //     setCookie('language', item.language)
            //     this.$store.dispatch('setLanguageName', item.name)
            //     document.documentElement.setAttribute('language', item.language)
            //     setTimeout(() => {
            //         this.$i18n.locale = item.language
            //     }, 500)
            // },
            changeCurtSelectLang(item) {
                this.$emit('closeLangModal')
                this.currentSelectLang = item.language
                let path = this.$route.path
                let paramsObj = this.$route.query
                this.$router.replace({
                    path: path,
                    query: { ...paramsObj, language: item.language },
                })
                // this.$router.replace(`${path}?language=${item.language}`)
                setTimeout(() => {
                    location.reload()
                }, 200)
                setCookie('language', item.language)
                this.$store.dispatch('setLanguageName', item.name)
                document.documentElement.setAttribute('language', item.language)
                setTimeout(() => {
                    this.$i18n.locale = item.language
                }, 500)
            },
            getLanguageList() {
                getLanguageList().then((res) => {
                    this.langOptions = res.data || []
                })
            },
            show() {
                return new Promise((res, rej) => {
                    if (!this.layerDom || !this.panelDom) {
                        res()
                    } else {
                        gsap.timeline({
                            onComplete: res,
                            defaults: {
                                duration: 0.26,
                            },
                        })
                            .from(this.layerDom, {
                                backgroundColor: 'rgba(23, 23, 26, 0)',
                            })
                            .from(this.panelDom, { opacity: 0, y: 20 }, 0)
                    }
                })
            },
            hide() {
                return new Promise((res, rej) => {
                    if (!this.layerDom || !this.panelDom) {
                        res()
                    } else {
                        gsap.timeline({
                            onComplete: res,
                            defaults: {
                                duration: 0.26,
                            },
                        })
                            .to(this.layerDom, {
                                backgroundColor: 'rgba(23, 23, 26, 0)',
                            })
                            .to(this.panelDom, { opacity: 0, y: 20 }, 0)
                    }
                })
            },
        },
    }
</script>
<style lang="scss">
    [dir="ltr"] {
        .langHeaderUser {
            padding-left: 75px;
        }
    }
    [dir="rtl"] {
        .langHeaderUser {
            padding-right: 75px;
        }
    }
    .van-toast {
        z-index: 9999999 !important;
    }
    .langHeaderUser {
        display: flex;
        flex-direction: column;
        // padding-left: 75px;
        padding-bottom: 40px;
        margin-bottom: 40px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.15);
        .langHeaderUserEmail {
            color: rgba(255, 255, 255, 0.6);
        }
        .langHeaderUserId {
            margin-top: 5px;
            color: rgba(255, 255, 255, 0.6);
            i {
                margin-left: 10px;
            }
        }
    }
</style>
<style lang="scss" module>
    @import "../../assets/uemo-scss/scss/abstracts/_functions.scss";
    // .layer--lang-switch {
    //   //
    // }

    .lang-switch-panel {
        width: 100%;
        .panel-body {
            // margin-top: 68px;
            .scroll-box {
                overflow: auto;

                height: calc(var(--g--full-height) - 460px);
                // height: calc(var(--g--dvh, 1vh) * 100 - env(safe-area-inset-bottom) -
                // env(keyboard-inset-height, 0px) - 460px);
                // height: 1200px;
            }
        }
        .tab-bar {
            position: relative;

            width: 630px;
            margin: 0 auto;
            padding: 10px;

            border: 2px solid rgb(255, 255, 255 / 0.2);
            border-radius: 100px;

            grid-template-columns: 1fr auto;
            .select-shadow {
                position: absolute;

                border-radius: 100px;
                background-color: color(var(--g--color-theme--main));
            }
        }
        .tab-item {
            font-size: 26px;
            line-height: var(---g--z-index);

            position: relative;
            z-index: 10;

            padding: 18px 34px;

            text-align: center;

            color: color(var(--g--color-font--default), 0.6);
            &[data-active] {
                color: color(var(--g--color-font--default));
            }
        }
        .exchange-group,
        .lang-group {
            // width: 630px;
            width: 14.8rem;
            margin: 0 auto;
        }
        .group-title {
            font-size: 28px;
            font-weight: 500;

            margin-bottom: 50px;

            color: color(var(--g--color-font--default));
        }
        .group-body {
            gap: 16px;
            .option {
                font-size: 26px;
                padding: 30px 0;
                color: #fff;
                transition: color 0.26s ease;
                text-align: left;
                &[data-active] {
                    // color: color(var(--g--color-theme--main));
                    color: #ffc72b;
                }
            }
        }
    }
    .langFooter {
        position: fixed;
        // bottom: 11.733vw;
        bottom: 1rem;
        width: 100%;
        .langBtns {
            display: flex;
            justify-content: space-around;
            //               display: grid;
            // grid-template-columns: 1fr 1fr; /* 两列均分 */
            // gap: 10px; /* 设置按钮之间的间距 */
            .btn--connect-logIn {
                font-size: 28px;
                // font-weight: 500;
                line-height: 35px;
                padding: 26px 38px;
                text-align: center;
                color: #fff;
                border-radius: 100px;
                background-color: #242424;
                min-width: 8rem;
            }
            .btn--connect-register {
                font-size: 28px;
                // font-weight: 500;
                line-height: 35px;
                padding: 26px 38px;
                text-align: center;
                color: #fff;
                border-radius: 100px;
                // background-color: color(var(--g--color-theme--main));
                background-color: #ffc72b;
                min-width: 8rem;
            }
        }
        .downLoad {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 0.5rem;
            color: rgba(255, 255, 255, 0.3);
            span {
                margin-left: 0.2rem;
                font-size: 34px;
            }
        }
    }
    // .van-toast__text,
    // .van-toast__icon {
    //     z-index: 9999 !important;
    // }
</style>



// WEBPACK FOOTER //
// src/compontents/newHome/LanguageSwitch.vue